export default __webpack_public_path__ + "static/743-2639e3a875c2c732cc467d3bd24620a7.gif";